export enum RouteAuth {
  Ignore = 0,
  Authenticated = 1,
  Unauthenticated = 2,
}